import { styled } from '@mui/material/styles';

export const List = styled('ul')`
  margin: 30px 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

interface IListItem {
  selected: boolean;
}

export const ListItem = styled('li')<IListItem>`
  border-radius: 4px;
  margin: 0 3px;
  background-color: ${(props) =>
    props.selected ? props.theme.palette.secondary.main : 'transparent'};

  a {
    padding: 3px 9px;
    display: flex;
  }
`;
